import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})


export class FilterPipe implements PipeTransform {
  transform(items: any[], searchTerm: string): any {
    if (!items || !searchTerm) {
      return items;
    }
    return items.filter(item => (toLowerCaseWithoutAccents(item.nom).indexOf(toLowerCaseWithoutAccents(searchTerm)) !== -1 || item.code.indexOf(toLowerCaseWithoutAccents(searchTerm))) !== -1);
  }
}

function toLowerCaseWithoutAccents(nom: string): string {
  nom = nom.toLowerCase();
  nom = nom.replace(/é/g, "e");
  nom = nom.replace(/è/g, "e");
  nom = nom.replace(/ê/g, "e");
  nom = nom.replace(/ë/g, "e");
  nom = nom.replace(/à/g, "a");
  nom = nom.replace(/â/g, "a");
  nom = nom.replace(/ä/g, "a");
  nom = nom.replace(/î/g, "i");
  nom = nom.replace(/ï/g, "i");
  nom = nom.replace(/ô/g, "o");
  nom = nom.replace(/ö/g, "o");
  nom = nom.replace(/ù/g, "u");
  nom = nom.replace(/û/g, "u");
  nom = nom.replace(/ü/g, "u");
  nom = nom.replace(/ç/g, "c");
  nom = nom.replace(/æ/g, "ae");
  nom = nom.replace(/œ/g, "oe");
  nom = nom.replace(/’/g, "'");
  nom = nom.replace(/-/g, " ");
  return nom;
}
